
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/purchase",
      function () {
        return require("private-next-pages/employer/purchase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/purchase"])
      });
    }
  